import styled from 'styled-components'
import { media } from '../../utils'

export const HeaderContainer = styled.div`
  display: content;
  text-align: left;
  /* background-color: #a7c9cd; */
  box-shadow: none;
  width: 100%;
  /* position: fixed; */
  top: 0px;
  z-index: 999;
  margin-bottom: -60px;
/* 
  ${media.desktop`
        background-color: #a6c9cd;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 10px 20px;
    `} */
`

export default HeaderContainer



// WEBPACK FOOTER //
// ./src/components/layout/HeaderCleverStyle.js